import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
const json = require("json!./../../../resources/properties.json");

@Injectable()
export class LoginService {
    private token: string;
    private serverURL: string;

    constructor(private http: Http) {
        this.serverURL = json.api_url;
        this.getTokenService();
    }

    login(email: string, password: string) {
        /*
         * If we had a login api, we would have done something like this
         */
        let creds = "email=" + email +
            "&password=" + password;

        return this.http.post(this.serverURL + '/loginData', creds, {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        })
            .map((res: any) => {
                let data = res.json();
                if (data.token !== undefined) {
                    this.token = data.token;
                    localStorage.setItem('token', this.token);
                    localStorage.setItem('userName', data.user.name);
                    localStorage.setItem('idUser', data.user.id.toString());
                }
                return data;
            });

        //for the purpose of this cookbook, we will juste simulate that

        /*
        if (email === 'test' && password === 'test') {
          this.token = 'token';
          localStorage.setItem('token', this.token);
          return Observable.of('token');
        }*/

        //return Observable.throw('authentication failure');
    }

    register(formData: Object) {
        /*
         * If we had a login api, we would have done something like this
         */
        return this.http.post(this.serverURL + '/loginData/register', this.serializeObj(formData), {
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        })
            .map((res: any) => {
                let data = res.json();
                this.token = data.token;
                localStorage.setItem('token', this.token);
                localStorage.setItem('idUser', data.user_id.toString());
                localStorage.setItem('userName', data.user_name);
                return data;
            });

        //for the purpose of this cookbook, we will juste simulate that

        /*
        if (email === 'test' && password === 'test') {
          this.token = 'token';
          localStorage.setItem('token', this.token);
          return Observable.of('token');
        }*/

        //return Observable.throw('authentication failure');
    }


    logout() {
        /*
         * If we had a login api, we would have done something like this
    *
        return this.http.get(this.config.serverUrl + '/auth/logout', {
          headers: new Headers({
            'x-security-token': this.token
          })
        })
        .map((res : any) => {
          this.token = undefined;
          localStorage.removeItem('token');
        });
         */

        this.token = undefined;
        localStorage.removeItem('token');

        return true;
    }

    isLogged() {
        return !!localStorage.getItem('token');
    }

    getTokenService() {
        this.token = localStorage.getItem('token');
    }

    getToken() {
        return this.token;
    }

    getUserStatus(): Promise<any> {

        let token = localStorage.getItem('token');
        let authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        if (token != null && token != "") {

            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });
            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(res => {
                if (JSON.parse(res.text()).code == -1) {
                    return "guest";
                } else {
                    return JSON.parse(res.text());
                }
            }).catch(this.handleError);
        } else {
            return Promise.resolve({ role: "guest" });
        }

    }

    refresh() {
        this.getTokenService();
    }

    existsEmail(email: string) {
        return this.http.get(this.serverURL + '/usersData/existsEmail/' + email).toPromise()
            .then(res => {
                if (JSON.parse(res.text()).code == 1) {
                    return true;
                }
                else {
                    return false;
                }
            }, this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || "guest";
    }

    private handleError(error: any): Promise<any> {        
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    private serializeObj(obj: any): String {
        var result: any[] = [];

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/login/login.service.ts
 **/